import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import PoiStepper from '../../components/PoiStepper';

const PoiModule = () => (
  <div>
    <Switch>
      <Route path="/poi/run" component={PoiStepper} />
      <Route path="/poi/recents" component={PoiStepper} />
      <Route exact path="/poi" render={() => <Redirect to="/poi/run" />} />
      <Route exact path="/poi/restart" render={() => <Redirect to="/poi/run" />} />
    </Switch>
  </div>
);

export default PoiModule;



// WEBPACK FOOTER //
// ./src/containers/PoiModule/index.jsx